import { IAppState } from 'src/store/types';

export const getGlobalGrid = (state: IAppState) => state.globalGrid;
export const getGlobalGridContainerWidth = (state: IAppState) => state.globalGrid.gridContainerWidth;
